"use strict";

function classnames() {
  for (var e = [], s = 0; s < arguments.length; s++) {
    e[s] = arguments[s];
  }

  for (var t = "", a = new Set(), n = 0, r = e.join(" ").split(" "); n < r.length; n++) {
    var l = r[n];
    "" === l || a.has(l) || (a.add(l), t.length > 0 && (t += " "), t += l);
  }

  return t;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.classnames = classnames;